import React from 'react';
import { Activity, Server, AlertTriangle, Database } from 'lucide-react';
import { Card } from '../components/ui/Primitives';
export function SystemMonitoring() {
  return <div className="max-w-[1600px] mx-auto space-y-6" data-id="element-867">
      <div className="mb-6" data-id="element-868">
        <h1 className="text-xl font-semibold text-slate-900" data-id="element-869">
          System Monitoring
        </h1>
        <p className="text-sm text-slate-500" data-id="element-870">
          DevOps observability and infrastructure health.
        </p>
      </div>

      <div className="grid grid-cols-5 gap-4" data-id="element-871">
        <MetricCard title="Memory Usage" value="42%" icon={<Server className="w-4 h-4" data-id="element-873" />} data-id="element-872" />
        <MetricCard title="Cache Hit Rate" value="94.2%" icon={<Database className="w-4 h-4" data-id="element-875" />} data-id="element-874" />
        <MetricCard title="Queue Throughput" value="124/s" icon={<Activity className="w-4 h-4" data-id="element-877" />} data-id="element-876" />
        <MetricCard title="Error Rate" value="0.12%" icon={<AlertTriangle className="w-4 h-4 text-amber-500" data-id="element-879" />} data-id="element-878" />
        <MetricCard title="Async Apex Depth" value="12" icon={<Activity className="w-4 h-4" data-id="element-881" />} data-id="element-880" />
      </div>

      <div className="grid grid-cols-2 gap-6" data-id="element-882">
        <Card className="p-5 h-64 flex flex-col" data-id="element-883">
          <h2 className="text-sm font-semibold text-slate-800 mb-4" data-id="element-884">
            Event Ingestion Rate
          </h2>
          <div className="flex-1 bg-slate-50 rounded-lg border border-slate-100 flex items-center justify-center text-slate-400 text-sm" data-id="element-885">
            [Area Chart: Ingestion by Source]
          </div>
        </Card>
        <Card className="p-5 h-64 flex flex-col" data-id="element-886">
          <h2 className="text-sm font-semibold text-slate-800 mb-4" data-id="element-887">
            Error Rate Trend
          </h2>
          <div className="flex-1 bg-slate-50 rounded-lg border border-slate-100 flex items-center justify-center text-slate-400 text-sm" data-id="element-888">
            [Line Chart: Error Rate with Threshold]
          </div>
        </Card>
      </div>

      <div className="grid grid-cols-3 gap-6" data-id="element-889">
        <Card className="p-5" data-id="element-890">
          <h2 className="text-sm font-semibold text-slate-800 mb-4" data-id="element-891">
            Dead-letter Queue
          </h2>
          <div className="space-y-4" data-id="element-892">
            <DlqRow system="Bonzo" count={42} data-id="element-893" />
            <DlqRow system="GHL" count={128} data-id="element-894" />
            <DlqRow system="Five9" count={0} data-id="element-895" />
          </div>
        </Card>
        <Card className="p-5" data-id="element-896">
          <h2 className="text-sm font-semibold text-slate-800 mb-4" data-id="element-897">
            Loop Guard
          </h2>
          <div className="text-3xl font-bold text-emerald-600 font-mono mb-2" data-id="element-898">
            1,492
          </div>
          <div className="text-xs text-slate-500" data-id="element-899">
            Infinite loops prevented today. This is a good thing.
          </div>
        </Card>
        <Card className="p-5" data-id="element-900">
          <h2 className="text-sm font-semibold text-slate-800 mb-4" data-id="element-901">
            Deduplication
          </h2>
          <div className="text-3xl font-bold text-slate-700 font-mono mb-2" data-id="element-902">
            8,234
          </div>
          <div className="text-xs text-slate-500" data-id="element-903">
            Duplicate events dropped (15m window).
          </div>
        </Card>
      </div>
    </div>;
}
function MetricCard({
  title,
  value,
  icon
}: any) {
  return <Card className="p-4" data-id="element-904">
      <div className="flex items-center justify-between mb-2" data-id="element-905">
        <div className="text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-906">
          {title}
        </div>
        <div className="text-slate-400" data-id="element-907">{icon}</div>
      </div>
      <div className="text-2xl font-bold text-slate-900 font-mono" data-id="element-908">{value}</div>
    </Card>;
}
function DlqRow({
  system,
  count
}: any) {
  return <div className="flex items-center justify-between" data-id="element-909">
      <span className="text-sm font-medium text-slate-700" data-id="element-910">{system}</span>
      <div className="flex items-center gap-3" data-id="element-911">
        <span className={`text-sm font-mono ${count > 0 ? 'text-red-500 font-bold' : 'text-slate-400'}`} data-id="element-912">
          {count}
        </span>
        {count > 0 && <button className="text-xs text-electric-600 hover:underline" data-id="element-913">
            Reprocess
          </button>}
      </div>
    </div>;
}